import { createSlice } from "@reduxjs/toolkit";

export const erpValuesSlice = createSlice({
    name: "erpValues",
    initialState: {
        code1List: [],
        code2List: [],
        code3List: [],
        code4List: [],
        code5List: [],
        divisionList: [],
        departmentList: [],
        netsisGroupCodes : []
    },
    reducers: {
        clearState: (state) => {
            state.code1List = [];
            state.code2List = [];
            state.code3List = [];
            state.code4List = [];
            state.code5List = [];
            state.divisionList = [];
            state.departmentList = [];
            return state;
        },
        onSelectGroupCodes: (state, action) => {
            state.code1List = action.payload.code1List;
            state.code2List = action.payload.code2List;
            state.code3List = action.payload.code3List;
            state.code4List = action.payload.code4List;
            state.code5List = action.payload.code5List;
            state.netsisGroupCodes = action.payload.netsisGroupCodes;
            return state;
        },
        onSelectDivisionList: (state, action) => {
            state.divisionList = action.payload;
            return state;
        },
        onSelectdDepartmentList: (state, action) => {
            state.departmentList = action.payload;
            return state;
        },
    },
});
export const { clearState, onSelectGroupCodes, onSelectDivisionList, onSelectdDepartmentList } = erpValuesSlice.actions;



export const erpValuesReducer = erpValuesSlice.reducer;